import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

export interface ConventionOption {
  id: number;
  name: string;
  year: number | null;
}

@Injectable()
export class ConventionService {
  constructor(private readonly rest: RestService) {}

  // Newest first; the first one is the current convention
  getConventions(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/convention`);
  }

  getConventionById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/convention/${id}`);
  }

  createConvention(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/convention`, payload);
  }

  updateConvention(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/convention/${id}`, payload);
  }
}

export function buildConventionLabel(convention: { name?: string; year?: number | null }): string {
  if (!convention) {
    return '';
  }

  return convention.year ? `${convention.name} (${convention.year})` : `${convention.name || ''}`;
}
